<template>
  <b-container :dir="$store.state.rightAlign ? 'rtl' : 'ltr'">
    <h2 v-if="userRegistrationStatus == 1" class="mb-5">{{$t('createProfile.titleUpdate')}}</h2>
    <h2 v-else class="mb-5">{{$t('createProfile.title')}}</h2>
    <b-row>
      <b-col cols="6">
        <div class="headers">
          <h4 class="text-muted mb-3">{{$t('createProfile.contactHeading')}}</h4>
        </div>
        <b-form>
          <b-form-group label-for="input-1">
            <b-row>
              <b-col cols="4">
                <label>{{$t('createProfile.email')}}</label>
              </b-col>
              <b-col cols="8">
                <b-form-input disabled v-model="registration.email" type="text"></b-form-input>
              </b-col>
            </b-row>
          </b-form-group>

          <b-form-group label-for="input-1">
            <b-row>
              <b-col cols="4">
                <span class="required-span">*</span>
                <label>{{$t('createProfile.fNameLabel')}}</label>
              </b-col>
              <b-col cols="8">
                <b-form-input
                  v-model="$v.registration.firstname.$model"
                  :state="$v.registration.firstname.$dirty ? !$v.registration.firstname.$error : null"
                  type="text"
                  :placeholder="$t('createProfile.fNamePlaceholder')"
                ></b-form-input>
                <b-form-invalid-feedback>{{$t('createProfile.requiredValidationMessage')}}</b-form-invalid-feedback>
              </b-col>
            </b-row>
          </b-form-group>

          <b-form-group label-for="input-2">
            <b-row>
              <b-col cols="4">
                <span class="required-span">*</span>
                <label>{{$t('createProfile.lNameLabel')}}</label>
              </b-col>
              <b-col cols="8">
                <b-form-input
                  v-model="$v.registration.lastname.$model"
                  :state="$v.registration.lastname.$dirty ? !$v.registration.lastname.$error : null"
                  :placeholder="$t('createProfile.lNamePlaceholder')"
                ></b-form-input>
                <b-form-invalid-feedback>{{$t('createProfile.requiredValidationMessage')}}</b-form-invalid-feedback>
              </b-col>
            </b-row>
          </b-form-group>

          <b-form-group label-for="input-2">
            <b-row>
              <b-col cols="4">
                <label>{{$t('createProfile.contactLabel')}}</label>
              </b-col>
              <b-col cols="8">
                <b-form-input
                  v-model="registration.contactNumber"
                  :placeholder="$t('createProfile.contactPlaceholder')"
                ></b-form-input>
              </b-col>
            </b-row>
          </b-form-group>

          <b-form-group label-for="input-2">
            <b-row>
              <b-col cols="4">
                <label>{{$t('createProfile.jobTitleLabel')}}</label>
              </b-col>
              <b-col cols="8">
                <b-form-input
                  v-model="registration.jobTitle"
                  :placeholder="$t('createProfile.jobTitlePlaceholder')"
                ></b-form-input>
              </b-col>
            </b-row>
          </b-form-group>
        </b-form>
      </b-col>
      <b-col cols="6">
        <div class="headers">
          <h4 class="text-muted mb-3">{{$t('createProfile.passwordHeading')}}</h4>
        </div>
        <b-form>
          <b-form-group label-for="input-1">
            <b-row>
              <b-col cols="4">
                <span class="required-span">*</span>
                <label>{{$t('createProfile.currentPasswordLabel')}}</label>
              </b-col>
              <b-col cols="8">
                <b-form-input
                  v-model="$v.registration.currentPassword.$model"
                  :state="$v.registration.currentPassword.$dirty ? !$v.registration.currentPassword.$error : null"
                  type="password"
                  :placeholder="$t('createProfile.currentPasswordPlaceholder')"
                ></b-form-input>
                <b-form-invalid-feedback>{{$t('createProfile.requiredValidationMessage')}}</b-form-invalid-feedback>
              </b-col>
            </b-row>
          </b-form-group>

          <b-form-group label-for="input-2">
            <b-row>
              <b-col cols="4">
                <span class="required-span">*</span>
                <label>{{$t('createProfile.newPasswordLabel')}}</label>
              </b-col>
              <b-col cols="8">
                <b-form-input
                  v-model="$v.registration.newPassword.$model"
                  :state="$v.registration.newPassword.$dirty ? !$v.registration.newPassword.$error : null"
                  type="password"
                  :placeholder="$t('createProfile.newPasswordPlaceholder')"
                ></b-form-input>
                <b-form-invalid-feedback>{{$t('createProfile.requiredValidationMessage')}}</b-form-invalid-feedback>
              </b-col>
            </b-row>
          </b-form-group>

          <b-form-group label-for="input-2">
            <b-row>
              <b-col cols="4">
                <span class="required-span">*</span>
                <label>{{$t('createProfile.confirmPasswordLabel')}}</label>
              </b-col>
              <b-col cols="8">
                <b-form-input
                  v-model="$v.registration.confirmNewPassword.$model"
                  :state="$v.registration.confirmNewPassword.$dirty ? !$v.registration.confirmNewPassword.$error : null"
                  type="password"
                  :placeholder="$t('createProfile.confirmPasswordPlaceholder')"
                ></b-form-input>
                <b-form-invalid-feedback
                  class="error"
                  v-if="!$v.registration.confirmNewPassword.sameAsPassword"
                >{{$t('createProfile.paswordValidationMessage')}}</b-form-invalid-feedback>
              </b-col>
            </b-row>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-button
          class="float-right"
          type="button"
          @click="userRegistrationStatus == 1 ? updateRegistration() : onSubmit()"
          variant="primary"
        >{{$t('updateBtn')}}</b-button>
      </b-col>
    </b-row>
    <AppLoaderModal :content="$t('createProfile.loaderMessage')" />
  </b-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import AppLoaderModal from "../components/Loader/LoaderModal";
import { Helper } from "../helpers";
import { HTTP } from "../utils/HTTP";
import uid from "uid";
import Cryptr from "cryptr";
import { validationMixin } from "vuelidate";
import { required, sameAs, minLength } from "vuelidate/lib/validators";
export default {
  name: "RegisterPage",
  mixins: [validationMixin],
  components: {
    AppLoaderModal
  },
  data() {
    return {
      registration: {
        email: localStorage.getItem("userEmail"),
        firstname: null,
        lastname: null,
        jobTitle: null,
        contactNumber: null,
        currentPassword: null,
        newPassword: null,
        confirmNewPassword: null,
        registrationStatus: 1
      },
      error: false,
      userGroupId: null,
      userRegistrationStatus: null
    };
  },
  computed: {
    // ...mapState('account', ['status'])
  },
  created() {
    // reset login status
    //this.logout();
  },
  mounted() {
    // console.log("-------", localStorage.getItem("registrationStatus"));
    this.userGroupId = localStorage.getItem("userGroupId");
    this.userGroupId = localStorage.getItem("userGroupId");
    this.userRegistrationStatus = localStorage.getItem("registrationStatus");
    this.registration.firstname =
      localStorage.getItem("userFirstname") == "null"
        ? ""
        : localStorage.getItem("userFirstname");
    this.registration.lastname =
      localStorage.getItem("userLastname") == "null"
        ? ""
        : localStorage.getItem("userLastname");
  },
  validations: {
    registration: {
      firstname: {
        required
      },
      lastname: {
        required
      },
      currentPassword: {
        required
      },
      newPassword: {
        required,
        minLength: minLength(6)
      },
      confirmNewPassword: {
        sameAsPassword: sameAs("newPassword")
      }
    }
  },
  methods: {
    // ...mapActions('account', ['login', 'logout']),

    onSubmit(e) {
      this.$v.registration.$touch();
      if (this.$v.registration.$anyError) {
        return;
      } else {
        // console.log("e", e);
        this.updateRegistration();
      }
    },

    async updateRegistration() {
      let registration = this.registration;
      let token = "Bearer " + localStorage.getItem("accessToken");
      let userId = localStorage.getItem("userId");
      try {
        let result = await HTTP(
          "post",
          "v1/mytpp/registration/update",
          {
            userId: userId,
            registration
          },

          {
            Authorization: token
          },
          null,
          true
        );
        if (result.data.success == 1) {
          localStorage.setItem("registrationStatus", 1);
          localStorage.setItem("userFirstname", this.registration.firstname);
          localStorage.setItem("userLastname", this.registration.lastname);
          let userFullName = localStorage.setItem(
            "userFullname",
            this.registration.firstname + " " + this.registration.lastname
          );
          if (this.userGroupId == 16) {
            this.$router.push("/dashboard");
          }
        }
      } catch (error) {}
    }
  }
};
</script>

<style scoped>
.headers {
  display: flex;
  justify-content: center;
  margin-left: 8rem;
}
</style>
